"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.splitMetadataAndContent = (md) => {
    const re = /---\n((.|\n)*)---/m;
    const matched = md.match(re);
    const match = matched && matched[1] ? matched[1] : null;
    return [match || '', md.replace(re, '')];
};
//# sourceMappingURL=splitMetadataAndContent.js.map